import React, { useEffect, useState } from 'react';

function WebinarTimer({ startTime })
{
	const [ timeLeft, setTimeLeft ] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

	useEffect(() =>
	{
		const calculateTimeLeft = () =>
		{
			const now = new Date();
			const meetingTime = new Date(startTime);
			const diff = meetingTime - now;

			if (diff > 0)
			{
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((diff % (1000 * 60)) / 1000);

				setTimeLeft({ days, hours, minutes, seconds });
			}
			else
			{
				setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 }); // Time is up
			}
		};

		calculateTimeLeft(); // Initial calculation
		const timer = setInterval(calculateTimeLeft, 1000); // Declare and initialize timer

		return () =>
		{
			clearInterval(timer); // Cleanup on unmount
		};
	}, [ startTime ]);

	const hasMeetingStarted = timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0;

	return (
		<div className='flexInline aCntr jEvenly eventTimeDiv gap4'>
			{ hasMeetingStarted && startTime ?
				<span> Webinar has started </span>
				:
				<>
					<div className='flexInlineCol textCntr jCntr'>
						<small className='lTxt txt12'>DD</small>
						<p>{timeLeft?.days ? (timeLeft?.days > 9 ? timeLeft?.days : `0${timeLeft?.days}`) : '00'}</p>
					</div>
					<div className='flexInlineCol textCntr jCntr'>
						<small className='pdngLXXS lTxt txt12'>: HH </small>
						<p className='pdngLXXS'>: {timeLeft?.hours ? (timeLeft?.hours > 9 ? timeLeft?.hours : `0${timeLeft?.hours}`) : '00'}</p>
					</div>
					<div className='flexInlineCol textCntr'>
						<small className='pdngLXXS lTxt txt12'>: MM </small>
						<p className='pdngLXXS'>: {timeLeft?.minutes ? (timeLeft?.minutes > 9 ? timeLeft?.minutes : `0${timeLeft?.minutes}`) : '00'}</p>
					</div>
					<div className='flexInlineCol textCntr'>
						<small className='pdngLXXS lTxt txt12'>: SS</small>
						<p className='pdngLXXS'>: {timeLeft?.seconds ? (timeLeft?.seconds > 9 ? timeLeft?.seconds : `0${timeLeft?.seconds}`) : '00'}</p>
					</div>
				</>
			}
		</div>
	);
}

export default WebinarTimer;